import { ClientCommunicationListingModel } from "@common/models";
import { SRClientCommunicationListingModel } from "@common/models/signalRTransport/SRClientCommunicationListingModel";
import { ClientSMSHub } from "@common/stores/hubs/ClientSMSHub";
import { IDisposable } from "@common/types";
import { action, computed, makeObservable, observable } from "mobx";

/**
 * This class subscribes to things SMS related on the ClientSMSHub and updates some observables when things happen 
 */
/**
 * Represents a store for subscribing to client SMS hub events.
 */
export class ClientSMSHubSubscriberStore implements IDisposable {
    clientSMSHub: ClientSMSHub;   
    @observable private _isNewIncomingMessage: boolean = false; 
    @observable private _incomingMessageClientId: number = 0; 
    private _incomingMessage: ClientCommunicationListingModel | undefined = undefined;

    constructor() {
        this.clientSMSHub = ClientSMSHub.currentInstance;        
        makeObservable(this, undefined, { autoBind: true })
        this.subscribeToHubEvents();
    }

    @computed get IsNewIncomingMessage() {
        return this._isNewIncomingMessage;
    }

    @computed get IncomingMessage() {
        return this._incomingMessage;
    }

    @computed get IncomingMessageClientId() {
        return this._incomingMessageClientId;
    }

    @action.bound setNewIncomingMessage(isNewIncomingMessage: boolean = true) {
        this._isNewIncomingMessage = isNewIncomingMessage;
    }
    /**
     * Subscribes or unsubscribes from hub events.
     * 
     * @param unsubscribe - A boolean indicating whether to unsubscribe from the hub events. Default is `false`.
     */
    private subscribeToHubEvents(unsubscribe: boolean = false) {
        const method = !unsubscribe ? this.clientSMSHub.registerMethod : this.clientSMSHub.unregisterMethod;
        method({ eventName: "onNewClientSMSMessage", callback: this.onNewClientSMSMessage });
    }

    dispose() {
        this.subscribeToHubEvents(true);
    }


    /**
     * Handles the event when a new SMS message is received for a client.
     * @param clientCommunication - The SRClientCommunicationListingModel representing the client communication.
     */
    @action.bound onNewClientSMSMessage(clientCommunication: SRClientCommunicationListingModel) {
        this._incomingMessageClientId = clientCommunication.clientId;
        this._isNewIncomingMessage = true;
        this._incomingMessage = new ClientCommunicationListingModel((clientCommunication.clientCommunication) as any);
    }
}
